"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Button = void 0;

var _react = _interopRequireDefault(require("react"));

var _view = require("../view");

var _spinner = require("../spinner");

var _text = require("../text");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

var Button = function Button(_ref) {
  var children = _ref.children,
      extend = _ref.extend,
      _ref$variant = _ref.variant,
      variant = _ref$variant === void 0 ? 'default' : _ref$variant,
      _ref$subVariant = _ref.subVariant,
      subVariant = _ref$subVariant === void 0 ? 'default' : _ref$subVariant,
      disabled = _ref.disabled,
      isLoading = _ref.isLoading,
      props = _objectWithoutProperties(_ref, ["children", "extend", "variant", "subVariant", "disabled", "isLoading"]);

  return /*#__PURE__*/_react["default"].createElement(_view.View, _extends({
    as: "button",
    disabled: disabled
  }, props, {
    extend: [rootCSS({
      variant: variant,
      subVariant: subVariant,
      disabled: disabled
    }), extend]
  }), /*#__PURE__*/_react["default"].createElement(_text.Text, {
    variant: "body",
    bold: true,
    extend: {
      display: 'flex',
      alignItems: 'center'
    }
  }, !isLoading ? children : /*#__PURE__*/_react["default"].createElement(_view.View, {
    extend: {
      width: 20,
      height: 20,
      '& > .loader': {
        width: 20,
        height: 20,
        '& > svg': {
          width: 20,
          height: 20
        }
      }
    }
  }, /*#__PURE__*/_react["default"].createElement(_spinner.Spinner, null))));
};

exports.Button = Button;

var rootCSS = function rootCSS(_ref2) {
  var variant = _ref2.variant,
      subVariant = _ref2.subVariant,
      disabled = _ref2.disabled;
  return function (_ref3) {
    var _ref3$theme = _ref3.theme,
        colors = _ref3$theme.colors,
        grid = _ref3$theme.grid,
        shadows = _ref3$theme.shadows,
        radius = _ref3$theme.radius;
    return _objectSpread(_objectSpread({
      position: 'relative',
      padding: "".concat(1.5 * grid, "px ").concat(3 * grid, "px"),
      background: colors.bg,
      transition: 'all 150ms ease-in-out',
      borderRadius: radius,
      border: 'none',
      cursor: 'pointer',
      textTransform: 'uppercase',
      whiteSpace: 'nowrap',
      '& > *': {
        textDecoration: 'none'
      },
      '& > p': {
        color: 'white'
      }
    }, subVariant === 'icon' && {
      width: 45,
      height: 45,
      borderRadius: '50%',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      padding: 0
    }), {}, {
      extend: [{
        condition: variant === 'default',
        style: {
          backgroundColor: colors.primary,
          '&:hover': {
            backgroundColor: colors.primaryDark
          }
        }
      }, {
        condition: variant === 'destructive',
        style: {
          background: colors.red,
          border: 'none',
          '& > p': {
            color: colors.bg
          }
        }
      }, {
        condition: variant === 'destructive-clear',
        style: {
          color: colors.red,
          border: "1px solid ".concat(colors.border),
          '& > p': {
            color: colors.red
          }
        }
      }, {
        condition: variant === 'clear',
        style: {
          border: "1px solid ".concat(colors.border),
          '& > p': {
            color: colors.primary
          }
        }
      }, {
        condition: disabled,
        style: {
          background: colors.disabled,
          boxShadow: 'none',
          cursor: 'normal',
          '&:hover': {
            backgroundColor: colors.diffuse
          }
        }
      }]
    }, !disabled && {
      '&:hover': {
        boxShadow: shadows.big
      }
    });
  };
};